import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import GamesGrid from "./GamesGrid";
import "./GameLayout.css";

const GameLayout = () => {
  const location = useLocation();
  const isGamesRoute = location.pathname === "/games";

  return (
    <div className={`GameLayout ${isGamesRoute ? 'has-grid' : ''}`}>
      {isGamesRoute && <GamesGrid />}
      <Outlet />
    </div>
  );
};

export default GameLayout;
